import React from 'react';
import { Dialog, DialogTitle, DialogContent, Divider, Box, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';

interface PreSubmitCaseModalProps {
  open: boolean;
  title: string;
  message: React.ReactNode;
  loading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const PreSubmitCaseModal: React.FC<PreSubmitCaseModalProps> = ({ open, title, message, loading, onConfirm, onCancel }) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth='sm' fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box>{message}</Box>
      </DialogContent>
      <Divider />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2, gap: 2 }}>
        <Button variant='outlined' onClick={onCancel}>Go Back</Button>
        <LoadingButton variant='contained' color='secondary' onClick={onConfirm} loading={loading}>Submit</LoadingButton>
      </Box>
    </Dialog>
  );
};

export default PreSubmitCaseModal;
